import { ReactNode } from "react";
import { Suspense } from "react";
import Loading from "./Loading";

interface SuspenseProps {
  children: ReactNode;
}

const SuspenseWithLoading: React.FC<SuspenseProps> = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default SuspenseWithLoading;